module.exports = __webpack_public_path__ + "img/icons for DS Logistik SPIM.-13.4ad17774.svg";